import { SavedSearchNS } from '../../saved-searches/models/saved-search.models';

export namespace WorkflowModelsNS {

    export enum TriggerTypeEnum {
        CREATED = 1,
        CREATED_EDITED = 2,
        CREATED_EDITED_CRITERIA = 3,
        TIME_DEPENDENT = 4,
        RUNNOW = 5,
        MASS_EDIT = 6
    }

    export enum WorkflowTypeEnum {
        EVENT_BASED = 1,
        TIME_DEPENDENT = 2
    }

    export enum WorkflowNotificationTypeEnum {
        EMAIL = 1,
        WHATSAPP = 2
    }

    export enum WorkflowEmailAssignedType {
        User = 1,
        Lead,
        Account,
        Territory,
        Vendor,
        Location,
        Contact
    }

    export enum OccurrenceTypeEnum {
        INSTANT = 1,
        TIME_DEPENDENT = 2
    }


    export enum WorkflowExecutionStatus {
        NoStatus = 0,
        Executing = 1,
        Executed,
        Failed,
        Pending,
        None
    }

    export enum WorkflowOccurrenceTypsEnum {
        Years = 1,
        Months,
        Days,
        Hours,
        Minutes,
        Seconds,
    }

    export enum WorkflowScheduleTypesEnum {
        None,
        Once = 1,
        Recurring
    }

    export enum WorkflowActionTypeEnum {
        SelectActionType = 0,
        AddTask = 1,
        AddEmailAlert,
        AddSmsAlert,
        UpdateField,
        CreateRecord,
        UpdateRecord,
        ConvertToInvoice,
        AddWhatsAppAlert,
        DeleteRecord,
        ConvertToSalesOrder,
        Approval,
        OutboundMessage,
        ItemReciept,
    }

    export enum WorkflowCreateRecordType {
        SalesOrder = 1,
        Estimate,
        Invoice,
        CreditMemo,
        Purchase,
        BillOrder,
        VendorCredit
    }

    export enum WorkflowUpdateRecordDiscountType {
        FreeProduct = 1,
        DiscountAmount,
        QtyDiscount,
        AdditionalHandlingCharge,
        QtyHandlingCharge,
        TaxRateHandling
    }

    export enum WorkflowUpdateFieldOperationType {
        Update,
        Append,
        Remove
    }

    export enum WorkflowTaskTypesEnum {
        IndividualTask = 1,
        GroupTask = 2
    }

    export enum WorkflowConversionTypeEnum {
        SalesOrder = 1,
        Invoice,
        PurchaseOrder
    }

    export enum EmailRecipientType {
        TO = 1,
        CC = 2,
        BCC = 3
    }

    export const WorkflowConversionTypeNames = [
        'None',
        'Sales Order',
        'Invoice',
        'Item Receipt',
    ]

    export const WorkflowUpdateRecordOfferTypes = [
        'None',
        'Discounted Product',
        'Additional Discount',
        'Qty Discount',
        'By Order Handling Fees',
        'By Item Handling Fees',
        'Tax Handling'
    ]

    export enum WorkflowOfferedQtyOperators {
        IsGreaterThan = 1,
        IsLessThan,
        IsEqualTo,
        IsNotEqualTo,
        IsGreaterThanEqualTo,
        Between,
        NotBetween,
        IsLessThanEqualTo
    }

    export const WorkflowOfferedQtyOperatorNames = [
        'None',
        'Greater Than',
        'Less Than',
        'Equal To',
        'Not Equal To',
        'Greater Than and Equal',
        'Between',
        'Not Between',
        'Less Than and Equal'
    ]

    export enum WorkflowUpdateFieldValueType {
        Value = 1,
        Expression
    }

    export type WorkflowActionType = 'manual'|'savedsearch';

    export type WorkflowActionOrders = {
        executionOrder: number;
        name: string;
        code: string;
    }

    export const WorkflowActionDefaultOrders: WorkflowActionOrders[] = [
        {executionOrder: 0, name: 'Tasks', code: 'workflowActionTasks'},
        {executionOrder: 0, name: 'E-mail Alerts', code: 'workflowActionEmails'},
        {executionOrder: 0, name: 'Update Fields', code: 'workflowActionUpdateFields'},
        {executionOrder: 0, name: 'Create Records', code: 'workflowActionCreateRecords'},
        {executionOrder: 0, name: 'Update Records', code: 'workflowActionUpdateRecords'},
        {executionOrder: 0, name: 'Delete Records', code: 'workflowActionDeleteRecords'},
        {executionOrder: 0, name: 'Convert', code: 'workflowActionConvertToInvoices'},
        {executionOrder: 0, name: 'Approvals', code: 'workflowActionApprovals'},
        {executionOrder: 0, name: 'Messages', code: 'workflowActionMessages'},
        {executionOrder: 0, name: 'Webhooks', code: 'workflowActionWebhooks'}
    ];

    //#region ***Workflow Add/Edit***
    export interface WorkflowAddedEditConditionGroup {
        id: number;
        conditionId: number;
        conditionNumber?: number;
        statusId: number;
        type: WorkflowActionType;
        savedSearchId?: number;
        isCombinational: boolean;
        ruleCombination: string;
        editedRuleData?: any;
        validData: boolean;
        errorMsg: string;
        ruleData: any[];
        instantActions?: {
            id: number;
            statusId: number;
            workflowConditionId?: number;
            workflowActionType: number;
            order: number;
            occurrenceType?: number;
            dateTimeFieldName: string;
            occurrenceBase?: number;
            occurrenceValue?: number;
            executionOrders: WorkflowActionOrders[];
            workflowActionTasks?: WorkflowAddEditActionTask[];
            workflowActionEmails?: WorkflowAddEditActionEmail[];
            workflowActionMessages?: WorkflowAddEditActionMessage[];
            workflowActionUpdateFields?: WorkflowAddEditActionUpdateFields[];
            workflowActionWebhooks?: WorkflowAddEditActionWebhook[];
            workflowActionCreateRecords?: WorkflowAddEditActionCreateRecord[];
            workflowActionUpdateRecords?: WorkflowAddEditActionUpdateRecord[];
            workflowActionConvertToInvoices?: WorkflowAddEditActionConvertToInvoice[];
            workflowActionDeleteRecords?: WorkflowAddEditActionDeleteRecords[];
            workflowActionApprovals?: WorkflowAddEditActionApprovals[];
        };
        timeDependentActions: WorkflowTimeDependentActions[]
    }

    export interface WorkflowTimeDependentActions {
        id?: number;
        statusId?: number;
        workflowConditionId?: number;
        workflowActionType?: number;
        occurrenceType?: number;
        addOrSubstractBase?: number;
        addOrSubstractBaseName?: string;
        dateTimeFieldName: string;
        dateTimeFieldLabel?: string;
        occurrenceBase: number;
        occurrenceBaseName?: string;
        occurrenceValue: number;
        executionOrders: WorkflowActionOrders[],
        workflowActionTasks?: WorkflowAddEditActionTask[];
        workflowActionEmails?: WorkflowAddEditActionEmail[];
        workflowActionMessages?: WorkflowAddEditActionMessage[];
        workflowActionUpdateFields?: WorkflowAddEditActionUpdateFields[];
        workflowActionWebhooks?: WorkflowAddEditActionWebhook[];
        workflowActionCreateRecords?: WorkflowAddEditActionCreateRecord[];
        workflowActionUpdateRecords?: WorkflowAddEditActionUpdateRecord[];
        workflowActionConvertToInvoices?: WorkflowAddEditActionConvertToInvoice[];
        workflowActionDeleteRecords?: WorkflowAddEditActionDeleteRecords[];
        workflowActionApprovals?: WorkflowAddEditActionApprovals[];
    }

    export interface WorkflowAddEditDetails {
        id?: number;
        organizationId: number;
        sequenceNumber: string;
        name: string;
        objectId: number;
        objectName: string;
        channelId: number;
        channelName: string;
        description: string;
        triggerType: number;
        occurrenceType: WorkflowScheduleTypesEnum;
        occurrenceBase: number;
        occurrenceValue: number;
        statusId: number;
        executionStatus: number;
        jobId?: string|null;
        scheduledDate?: string;
        validFromDate: string;
        validToDate: string;
        lastEndDate?: string|null;
        lastStartDate?: string|null;
        lastSuccessDate?: string|null;
        nextStartDate?: string;
        createdByUserName?: string;
        lastUpdatedByUserName?: string;
        workflowPermissions: WorkflowAddEditPermissions[];
        workflowConditions: WorkflowAddEditCondtions[];
        accountChannelId: number | null;
        accountChannelName: string | null;
        updatedDate?: string|null;
        createdDate?: string|null;
    }

    export interface WorkflowAddEditPermissions {
        id?: number;
        workflowId: number;
        userId: number;
        userName: string;
        statusId: number;
    }

    export interface WorkflowAddEditCondtions {
        id?: number;
        workflowId: number;
        isMannualCondition: boolean;
        saveSearchId: number;
        order: number;
        description: string;
        statusId: number;
        savedSearch: SavedSearchNS.NewSavedSearches|null;
        savedSearchUpdate: any|null;
        actionIds?: number[];
        workflowActions: WorkflowAddEditActions[]
    }

    export interface WorkflowAddEditActions {
        id: number;
        workflowConditionId?: number;
        workflowActionType: number;
        order: number;
        occurrenceType?: number;
        dateTimeFieldName: string;
        occurrenceBase?: number;
        occurrenceValue?: number;
        statusId: number;
        workflowActionTasks?: WorkflowAddEditActionTask[];
        workflowActionEmails?: WorkflowAddEditActionEmail[];
        workflowActionMessages?: WorkflowAddEditActionMessage[];
        workflowActionUpdateFields?: WorkflowAddEditActionUpdateFields[];
        workflowActionWebhooks?: WorkflowAddEditActionWebhook[];
        workflowActionCreateRecords?: WorkflowAddEditActionCreateRecord[];
        workflowActionUpdateRecords?: WorkflowAddEditActionUpdateRecord[];
        workflowActionConvertToInvoices?: WorkflowAddEditActionConvertToInvoice[];
        workflowActionDeleteRecords?: WorkflowAddEditActionDeleteRecords[];
        workflowActionApprovals?: WorkflowAddEditActionApprovals[];
    }

    export interface WorkflowAddEditActionTask {
        id?: number;
        statusId?: number;
        workflowActionId?: number;
        messageTemplateId: number;
        taskTitle: string;
        description: string;
        startDateBaseFieldName: string;
        addOrSubstractBase: number;
        addOrSubstractBaseName?: string;
        startDateAddOrSubstractValue: number;
        endDateAddOrSubstractValue: number;
        assignedType: number;
        taskCategoryId: number;
        taskCategoryName?: string;
        reminderTypeId: number;
        repeatTypeId: number;
        reminderInMinutes: number;
        prority: number;
        prorityName?: string;
        taskTypeId: number;
        isTaskOrdered: boolean;
        executionOrder?: number;
        workflowActionTaskSharedWiths: {
            id: number;
            workflowActionTaskId: number;
            userId: number;
            statusId: number;
        }[];
        workflowActionTaskAssignees:
          {
            id?: number;
            workflowActionTaskId?: number;
            userId: number;
            statusId: number
          }[];
        checkList?: string[];
        workflowActionChildTasks?: WorkflowAddEditActionChildTasks[];
        workflowTaskAttachments: WorkflowTaskActionAttachments[];
    }

    export interface WorkflowAddEditActionChildTasks {
        id: number;
        statusId: number;
        workflowActionTaskId: number;
        description: string;
        startDateBaseFieldName: string;
        endDateAddOrSubstractValue: number;
        taskOrder: number;
        prority: number;
        prorityName?: string;
        assignedType: number;
        checkList?: string[];
        workflowActionChildTaskAssignees: {
            id?: number;
            workflowActionChildTaskId?: number;
            userId: number;
            name?: string;
            statusId: number
        }[];
    }

    export interface WorkflowTaskActionAttachments {
        workflowActionTaskId: number;
        id: number;
        fileName: string;
        displayFileName: string;
        filePath?: string;
        mediaType: string;
        fileSize: number;
        statusId: number;
        attachment: EmailTemplateAttachmentModel
    }

    export interface WorkflowAddEditActionEmail {
        id: number;
        statusId: number;
        workflowActionId: number;
        objectId: number;
        objectName: string;
        name: string;
        from: number;
        fromUserId: number;
        emailTemplateId: number;
        subject: string;
        body: string;
        isDetailAttached: boolean;
        notificationType: number;
        executionOrder?: number;
        workflowEmailTemplateFields?:
          {
            id: number;
            workflowActionEmailId: number;
            templateFieldName: string;
            fieldName: string;
            columnSettingId: number;
            displayOrder: number;
            statusId: number;
            isCustom: boolean;
          }[];
        workflowActionEmailList:
          {
            id: number;
            workflowActionEmailId: number;
            emailNotificationType: number;
            assignedType: number;
            assignedId: number;
            statusId: number;
          }[];
        workflowEmailAttachments: EmailTemplateAttachments[];
        workflowEmailSavedSearchs: WorkflowEmailSavedSearchs[];
    }
    export interface WorkflowEmailSavedSearchs {
        id: number;
        workflowActionEmailId: number;
        objectId: number;
        objectName: string;
        channelId: number;
        channelName: string;
        saveSearchId: number;
        saveSearchName: string;
        statusId: number;
    }
    export interface EmailTemplateAttachments {
        workflowActionEmailId: number;
        id: number;
        fileName: string;
        displayFileName: string;
        filePath?: string;
        mediaType: string;
        fileSize: number;
        statusId: number;
        oldAttachment?: EmailTemplateAttachmentModel,
        attachment: EmailTemplateAttachmentModel
    }

    export interface EmailTemplateAttachmentModel {
        id: number;
        createdSource: string;
        updatedSource: string;
        createdBy: number;
        updatedBy: number;
        createdDate: Date;
        updatedDate: Date;
        name: string;
        guidName: string;
        location?: string;
        content: string;
        file?: string;
        extension: string;
        mediaType?: string;
        sizeInBytes: number;
        description: string;
        statusId: number;
        isValid: boolean;
        validFromDate?: string;
        validToDate?: string;
        parentFolderId?: number;
        parentFolder?: string;
        isFolder?: boolean;
        isCloudUploaded?: boolean;
        organizationId?: number;
        downloadCount?: number;
        downloadLink?: string;
        moduleName: string;
        isModuleFolder: boolean;
    }

    export interface WorkflowAddEditActionMessage {
        workflowActionId: number;
        name: string;
        from: number;
        messageTemplateId: number;
        message: string;
        workflowMessageTemplateFields: [
          {
            workflowActionMessageId: number;
            templateFieldName: string;
            fieldName: string
          }
        ];
        workflowActionMessageList: [
          {
            workflowActionMessageId: number;
            assignedType: number;
            assignedId: 0
          }
        ]
    }

    export interface WorkflowAddEditActionWebhook {
        workflowActionId: number;
        name: string;
        description: string;
        apiUrl: string;
        httpMethod: number;
        authType: number;
        workflowWebhookBody: {
            workflowActionWebhookId: number;
            jsonDataType: number;
            jsonBody: string
        };
        workflowWebhookParameters: [
            {
            workflowActionWebhookId: number;
            parameterType: number;
            parameterName: string;
            parameterValue: string
            }
        ]
    }

    export interface WorkflowAddEditActionUpdateFields {
        workflowActionId: number;
        id: number;
        objectId: number;
        objectName: string;
        labelName: string;
        fieldName: string;
        isCustom: boolean;
        formControlId: number;
        maxLengthAfterDecimal: number;
        operationType: number;
        fieldDataType: string;
        fieldValue: string;
        fieldValueType: number;
        executionOrder?: number;
        workflowUpdateFieldExpressionFields?: WorkflowUpdateFieldExpressionFields[];
        statusId: number;
        currencySymbol?: string;
    }

    export interface WorkflowUpdateFieldExpressionFields {
        id: number;
        workflowActionUpdateFieldId: number;
        fieldName: string;
        labelName: string;
        isCustom: boolean;
        statusId: number;
        objectId: number;
        objectName: string;
        displayOrder: number;
    }

    export interface WorkflowUpdateRecordExpressionFields {
        id: number;
        workflowActionUpdateRecordId: number;
        fieldName: string;
        labelName: string;
        isCustom: boolean;
        statusId: number;
        objectId: number;
        objectName: string;
        displayOrder: number;
    }

    export interface WorkflowAddEditActionCreateRecord {
        id: number;
        workflowActionId: number;
        createRecordType: number;
        objectId: number;
        objectName: string;
        channelId: number;
        channelName: string;
        locationId: number;
        locationName: string;
        paymentTermId: number;
        paymentMethodId: number;
        shippingTermId: number;
        shippingMethodId: number;
        salesRepId: number;
        customAttributes?: {
            customAttributeId: number;
            customAttributeValue: string[];
        }[];
        customAttributeInfos: {
            customAttributeId: number;
            customAttributeValue: string[];
        }[];
        isTableDiscountEnabled: boolean;
        discountId: number;
        discountTypeId: number;
        discountAmount: number;
        addlDiscountId: number;
        addlDiscountTypeId: number;
        addlDiscountAmount: number;
        handlingChargeId: number;
        handlingChargeTypeId: number;
        handlingChargeAmount: number;
        isFreeShipping: boolean;
        shippingAmount: number;
        statusId: number;
        executionOrder?: number;
        workflowCreateRecordProducts: WorkflowAddEditActionCreateRecordProducts[];
        products?: WorkflowAddEditActionRecordProductDetails[];
    }

    export interface WorkflowAddEditActionRecordSOCustoms {
        customAttributeId: number;
        customAttributeValue: string[];
        sectionCode: string;
        formControlId: number;
        labelName: string;
        field: string;
        isRequired: boolean;
        pickListValues: string[];
    }

    export interface WorkflowAddEditActionCreateRecordProducts {
        id: number;
        workflowActionCreateRecordId: number;
        productId: number;
        typeId: number;
        productUOMId: number;
        discountId: number;
        discountTypeId: number;
        discountAmount: number;
        handlingChargeId: number;
        handlingChargeTypeId: number;
        handlingChargeAmount: number;
        productQty: number;
        productPrice: number;
        bundleKitParentProductId?: number;
        statusId: number;
        bundleDetails?: any;
    }

    export interface WorkflowAddEditActionRecordProductDetails {
        id: number;
        name: string;
        itemNo: string;
        description: string;
        productUOM: {
            productId: number;
            barcode: string;
            unitOfMeasureId: number;
            uomName: string;
        }[];
        sellPrice: number;
        quantity: number;
        totalQuantity: number;
        amount: number;
        bundleDetails?: any;
    }

    export interface WorkflowAddEditActionRecordQtyDiscount {
        id: number;
        workflowActionUpdateRecordId: number;
        operator: number;
        fromOrderedQty: number;
        toOrderedQty: number;
        discountId: number;
        discountTypeId: number;
        discountAmount: number;
        statusId: number;
    }

    export interface WorkflowAddEditActionUpdateRecord {
        id: number;
        workflowActionId: number;
        objectId: number;
        objectName: string;
        offerType: number;
        offerOnProduct?: WorkflowAddEditActionRecordProductDetails;
        offerOnLocationId: number;
        offerOnProductId: number;
        offerOnProductUOMId: number;
        minOrderQty: number;
        offeredProduct?: WorkflowAddEditActionRecordProductDetails;
        offeredLocationId: number;
        offeredProductId: number;
        offeredProductUOMId: number;
        offeredQty: number;
        discountId: number;
        discountTypeId: number;
        discountAmount: number;
        taxRateId: number;
        isTaxExempted: boolean;
        workflowUpdateRecordQtyDiscounts: WorkflowAddEditActionRecordQtyDiscount[];
        taxExemptedProducts?: WorkflowUpdateActionTaxExemptedProducts[];
        isAdditionalDiscount: boolean;
        statusId: number;
        executionOrder?: number;
        maxLengthAfterDecimal: number;
        fieldValueType: number;
        expressionValue: string;
        workflowUpdateRecordExpressionFields?: WorkflowUpdateRecordExpressionFields[];
    }

    export interface WorkflowUpdateActionTaxExemptedProducts {
        id: number;
        offeredProduct?: WorkflowAddEditActionRecordProductDetails;
        offerOnProductUOMId: number;
        taxRateId: number;
    }

    export interface WorkflowAddEditActionConvertToInvoice {
        id: number;
        workflowActionId: number;
        objectId: number;
        objectName: string;
        conversionType: WorkflowConversionTypeEnum;
        billStatus: boolean;
        statusId: number;
        executionOrder?: number;
    }

    export interface WorkflowAddEditActionDeleteRecords {
        id: number;
        workflowActionId: number;
        objectId: number;
        objectName: string;
        changeStatus: number;
        statusId: number;
        executionOrder?: number;
    }

    export interface WorkflowAddEditActionApprovals {
        id: number;
        workflowActionId: number;
        objectId: number;
        objectName: string;
        assignedType: number;
        roleId: number;
        assignedId: number;
        assignedUser?: any,
        approvalSequence: number;
        isApprovalSequenceEnabled: boolean;
        statusId: number;
        executionOrder?: number;
    }

    export interface WorkflowHistoryDetails {
        id: number;
        workflowId: number;
        executionStatus: string;
        occurrenceType: string;
        savedSearchColumnSetting?: any[];
        taskData?: string;
        triggeredDate: string;
        workflowActionId: number;
        workflowActionTaskId: number;
        workflowActionType: string;
        workflowConditionId: number;
        objectId: number;
        objectName: string;
    }

    //#endregion

    //#region ***Workflow Details***
    export interface WorkflowDetails extends WorkflowAddEditDetails {
        workflowConditions: WorkflowDetailsConditions[];
    }

    export interface WorkflowDetailsConditions extends WorkflowAddEditCondtions {
        savedSearchInfo: WorkflowSavedSearchInfo;
    }

    export interface WorkflowSavedSearchInfo {
        id: number;
        createdSource: string;
        updatedSource: string;
        createdBy: number;
        updatedBy: number;
        createdDate: string;
        updatedDate: string;
        organizationId: number;
        name: string;
        description: string;
        statusId: number;
        status: {
            id: number;
            createdSource: string;
            updatedSource: string;
            createdBy: number;
            updatedBy: number;
            createdDate: string;
            updatedDate: string;
            name: string;
            description: string;
            groupId: number;
            typeId: number;
        };
        isValid: boolean,
        isCombinational: boolean;
        ruleCombination: string;
        validFromDate: string;
        validToDate: string;
        savedSearchRule: WorkflowSavedSearchRules[],
        savedSearchUserPermission: any[],
        savedSearchColumnSetting: [],
        previewId: number;
        isPreview: boolean,
        savedSearchGroupBy: string;
        isWorkflowSavedSearch: boolean
    }

    export interface WorkflowSavedSearchRules {
        id: number;
        createdSource: string;
        updatedSource: string;
        createdBy: number;
        updatedBy: number;
        createdDate: string;
        updatedDate: string;
        savedSearchId: number;
        objectId: number;
        objectName: string;
        isMainModule: boolean,
        criteria: string;
        equation: string;
        values: string[],
        valueRefId: string[],
        operator: string;
        isCustom: boolean,
        dataType: string;
        statusId: number;
        status: {
          id: number;
          createdSource: string;
          updatedSource: string;
          createdBy: number;
          updatedBy: number;
          createdDate: string;
          updatedDate: string;
          name: string;
          description: string;
          groupId: number;
          typeId: number;
        };
        isValid: boolean,
        sequenceOrder: number;
        templateId: number;
        accountChannelId: number;
        templateName: string;
        validFromDate: string;
        validToDate: string;
        savedSearchRuleDetails: WorkflowSavedSearchRuleDetails[],
        labelName: string;
    }

    export interface WorkflowSavedSearchRuleDetails {
        id: number;
        createdSource: string;
        updatedSource: string;
        createdBy: number;
        updatedBy: number;
        createdDate: string;
        updatedDate: string;
        saveSearchRuleId: number;
        values: string;
        statusId: number;
        status: {
          id: number;
          createdSource: string;
          updatedSource: string;
          createdBy: number;
          updatedBy: number;
          createdDate: string;
          updatedDate: string;
          name: string;
          description: string;
          groupId: number;
          typeId: number;
        };
        isValid: boolean,
        validFromDate: string;
        validToDate: string;
    }

    //#endregion
}
